import { MSEnum } from '@/common/enumeration';
import TaxReturnAPI from '@/api/TaxReturnAPI.js';
import ServiceRegisDecAPI from '@/api/ServiceRegisDecAPI.js';
import httpClient from '../../../api/axios-httpclient';

export default {
	/**
	 * Lấy tất cả danh sách tờ khai trên hệ thống gồm cả tiêu đề
	 */
	getTaxReturn: async function(context, payload) {
		let url = TaxReturnAPI.getAPIUrl() + '/all';
		let res = await httpClient.getAsync({
			url: url,
			params: payload
		});

		if (res.Data) {
			return res.Data;
		}

		return null;
	},

	/**
	 * Lấy danh sách phụ lục của tờ khai
	 */
	getDeclareAdditional: async function(context, payload) {
		let url = TaxReturnAPI.getAPIUrl() + '/getadditional';
		let res = await httpClient.getAsync({
			url: url,
			params: payload
		});

		if (res.Data) {
			return res.Data;
		}

		return null;
	},

	getTaxReturnType: async function(context, payload) {
		let url = TaxReturnAPI.getAPIUrl() + '/gettaxreturntype';
		let res = await httpClient.getAsync({
			url: url
		});

		if (res.Success) {
			context.commit('updateTaxReturnTypeData', res.Data);
		} else {
			context.commit('updateTaxReturnTypeData', []);
		}
	}
};
